// =============================================================
// 檔案名稱：marketOperationLogService.js
// 版本：V1.01
// 日期：2025/07/19
// 主要功能與職責：
//   提供市場操作紀錄寫入服務，供新增/刪除市場時呼叫。
// 這個檔案是做什麼的？
//   統一管理市場操作紀錄寫入，確保資料一致性。
// 解決了什麼問題？
//   讓所有市場操作都能正確記錄到 Firestore。
// 注意事項：
//   關連檔案：App.js, AdminPanel.js, MarketOperationLogs.js
// -------------------------------------------------------------
// V1.01 2025/07/19 初版
// =============================================================

import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

/**
 * 寫入市場操作紀錄
 * @param {object} db - Firestore 實例
 * @param {string} appId - 專案 ID
 * @param {string} action - 操作類型 ('add' | 'delete')
 * @param {object} market - 市場物件，需含 id, name, region
 * @param {object} currentUser - 當前使用者，需含 id, name
 */
export async function logMarketOperation(db, appId, action, market, currentUser) {
  if (!db || !appId || !action || !market || !currentUser) return;
  const logColPath = `artifacts/${appId}/public/data/marketOperationLogs`;
  await addDoc(collection(db, logColPath), {
    action, // 'add' or 'delete'
    marketId: market.id || '',
    marketName: market.name || '',
    regionId: market.region || '',
    userId: currentUser.id || '',
    userName: currentUser.name || '',
    timestamp: new Date() // 立即可查詢的 JS Date
  });
} 